// extracted by mini-css-extract-plugin
module.exports = {"container":"Tag_container__5BFdD","text":"Tag_text__19VXY","middle":"Tag_middle__aeq9O","large":"Tag_large__3LOG-","sending":"Tag_sending__2BfrC"};